'use strict';

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }

        $(this)
            .find('input:visible, select:visible')
            .each(function () {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                    $(this).closest('.input-field').removeClass('valid');
                    valid = false;
                }
            });
    }
    let $this = $(this);
    if (!valid) {
        $this.closest('form').addClass('form-has-errors');
    } else {
        $this.closest('form').removeClass('form-has-errors');
    }
    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @param {boolean} isFormSubmit - check whether we are submitting the form or not
 * @returns {void}
 */
function clearForm(form, isFormSubmit = false) {
    let $form = $(form);
    if (!($form.hasClass('form-has-errors') && isFormSubmit)) {
        $form.find('.form-control.is-invalid').removeClass('is-invalid');
    }
}

module.exports = {
    invalid: function () {
        $(document).on('invalid', 'form input, form select', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow) && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort) && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback').text(validationMessage);
            }
        });
    },

    submit: function () {
        $(document).on('submit', 'form', function (e) {
            return validateForm.call(this, e);
        });
    },

    buttonClick: function () {
        $(document).on('click', 'form button[type="submit"], form input[type="submit"]', function () {
            // clear all errors when trying to submit the form
            clearForm($(this).parents('form'), true);
        });
    },

    functions: {
        validateForm: function (form, event) {
            return validateForm.call(form, event || null);
        },
        clearForm: clearForm,
    },
};
